import script from "./bonusView.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusView.vue?vue&type=script&setup=true&lang=ts"

import "./bonusView.vue?vue&type=style&index=0&id=1d79bd52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d79bd52"]])

export default __exports__